import { CRC32 } from "./CRC32";

export function GeneratePlanLink(planID) {
  var theURL = "launchPlanID=" + planID.toString();
  var crc = CRC32.str(theURL);
  theURL += "&crc=" + encodeURIComponent(crc);
  var dl = "dl=" + window.btoa(theURL);
  var origin = window.location.origin;
  var fullStr = origin + "/?" + dl;

  return fullStr;
}
